import { Component, ElementRef, Input } from '@angular/core';
import {
  FINAL_APPROVAL_STATES,
  FINAL_REJECTION_STATES,
  stateConfig,
} from '../models';

@Component({
  selector: 'irembogov-workflow-state',
  templateUrl: './state.component.html',
  styleUrls: ['./state.component.css'],
})
export class WorkflowStateComponent {
  @Input()
  config!: stateConfig;

  readonly stateColors = {
    approval: '#ccffcc',
    rejection: '#ffcccc',
    default: '#bbe1fa',
  };

  constructor(public el: ElementRef) {}

  getStateColor(): string {
    if (!this.config.name) {
      return this.stateColors.default;
    }

    const stateName = this.config.name.toUpperCase();

    if (FINAL_APPROVAL_STATES.some(state => stateName.includes(state))) {
      return this.stateColors.approval;
    }

    if (FINAL_REJECTION_STATES.some(state => stateName.includes(state))) {
      return this.stateColors.rejection;
    }

    return this.stateColors.default;
  }
}
